(() => {
  "use strict";

  const query = (selector, root = document) => root.querySelector(selector);
  const queryAll = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const escapeHtml = (value = "") => String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");
  const icons = {
    arrow: '<svg class="vc-arrow" viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h11M11 5l5 5-5 5"></path></svg>',
    star: '<svg class="ui-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 2.7 5.5 6.1.9-4.4 4.3 1 6.1-5.4-2.9-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z"></path></svg>',
    check: '<svg class="ui-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 4 4 10-10"></path></svg>',
    shield: '<svg class="ui-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 8 3v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z"></path><path d="m9 12 2 2 4-4"></path></svg>',
    badge: '<svg class="ui-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2 9.3 4.2 5.8 4 5 7.4 2.5 10 4 13l-.3 3.5 3.3 1.1 2 2.8 3-1 3 1 2-2.8 3.3-1.1L20 13l1.5-3L19 7.4 18.2 4l-3.5.2z"></path><path d="m9 12 2 2 4-4"></path></svg>',
    message: '<svg class="ui-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M21 11.5a8.4 8.4 0 0 1-8.5 8.5 8.2 8.2 0 0 1-4-.9L3 21l1.9-5.5a8.2 8.2 0 0 1-.9-4A8.4 8.4 0 0 1 12.5 3 8.4 8.4 0 0 1 21 11.5Z"></path></svg>',
  };
  const reviewStars = `<span class="vc-review-stars-visual" aria-hidden="true">${'<svg class="vc-review-star" viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="m12 1.9 3.09 6.26 6.91 1-5 4.88 1.18 6.88L12 17.67l-6.18 3.25L7 14.04l-5-4.88 6.91-1L12 1.9Z"></path></svg>'.repeat(5)}</span>`;

  function formatDate(value) {
    if (!value) return "Completed contract";
    return new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" }).format(new Date(value));
  }

  function formatDateRange(job) {
    const start = job.startedAt ? formatDate(job.startedAt) : "";
    const end = job.completedAt ? formatDate(job.completedAt) : "";
    return start && end ? `${start} – ${end}` : end || start || "Completed contract";
  }

  function formatMonth(value) {
    return new Intl.DateTimeFormat("en-GB", { month: "short", year: "numeric", timeZone: "UTC" }).format(new Date(value));
  }

  function reviewCopy(text, upwork) {
    if (!text) return "";
    if (text.length <= 470) return `<blockquote>“${escapeHtml(text)}”</blockquote>`;
    return `<details class="review-full-copy"><summary><span>“${escapeHtml(text.slice(0, 370).trim())}…”</span><b>Read the complete${upwork ? " Upwork" : ""} review <span aria-hidden="true">+</span></b></summary><blockquote>“${escapeHtml(text)}”</blockquote></details>`;
  }

  function archiveCard(review, index) {
    const upwork = review.platform === "Upwork";
    const platform = upwork ? "Upwork" : "Shopify Partner";
    const heading = upwork ? review.title : review.reviewer;
    const service = upwork ? review.category : review.service;
    const text = upwork ? review.clientFeedback : review.text;
    const tags = upwork && review.endorsements?.length
      ? `<div class="review-row-endorsements">${review.endorsements.map(item => `<span>${escapeHtml(item)}</span>`).join("")}</div>`
      : "";
    const footer = upwork
      ? `${review.rating ? `<span>${icons.star} Client rating ${review.rating}.0${review.reviewCount > 1 ? ` · ${review.reviewCount} reviews` : ""}</span>` : ""}<span>${icons.check} Completed contract</span><time datetime="${escapeHtml(review.completedAt || "")}">${escapeHtml(formatDateRange(review))}</time><a class="review-original-link" href="${escapeHtml(window.VivekCodes?.upworkUrl || "https://www.upwork.com/freelancers/itsvivekgupta")}" target="_blank" rel="noreferrer">Upwork profile <span class="vc-arrow" data-vc-direction="up-right" aria-hidden="true">↗</span></a>`
      : `<span>${icons.star} Quality ${review.qualityRating}.0</span><span>${icons.message} Communication ${review.communicationRating}.0</span><time datetime="${escapeHtml(review.date)}">${escapeHtml(formatMonth(review.date))}</time>`;
    return `<article class="complete-review-card complete-review-row${upwork ? " complete-review-row--upwork" : ""}" data-platform="${upwork ? "upwork" : "shopify"}"><div class="review-card-top"><span class="review-card-number">${String(index + 1).padStart(2, "0")}</span><span class="review-platform-badge${upwork ? " review-platform-badge--upwork" : ""}">${upwork ? icons.shield : icons.badge} ${platform}</span></div><div class="review-card-client"><div class="vc-review-heading vc-review-heading--archive"><h3>${escapeHtml(heading)}</h3><span class="vc-review-stars" role="img" aria-label="Five out of five stars">${reviewStars}</span></div><span>${escapeHtml(service)}</span></div><div class="review-row-copy">${reviewCopy(text, upwork)}${tags}</div><footer class="review-card-footer">${footer}</footer></article>`;
  }

  async function installReviewBrowsers() {
    const archive = query(".review-browser-v2");
    if (!archive || !window.VivekCodes?.reviewsUrl) return;

    const hasDeepLink = /^#review-\d+$/.test(window.location.hash);
    if (!hasDeepLink && "IntersectionObserver" in window) {
      await new Promise(resolve => {
        const observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          observer.disconnect();
          resolve();
        }, { rootMargin: "500px 0px" });
        observer.observe(archive);
      });
    }

    let data;
    try {
      const response = await fetch(window.VivekCodes.reviewsUrl, { credentials: "omit" });
      if (!response.ok) return;
      data = await response.json();
    } catch {
      return;
    }

    if (archive) {
      let platform = "All platforms";
      let service = "All services";
      let searchTerm = "";
      const requestedReview = window.location.hash.match(/^#review-(\d+)$/)?.[1];
      let deepLinkHandled = false;
      let visible = requestedReview ? data.all.length : 12;
      const tabs = queryAll(".review-platform-tabs button", archive);
      const input = query('.review-search input[type="search"]', archive);
      const select = query(".review-service-filter select", archive);
      const count = query(".review-result-count b", archive);
      const list = query(".complete-review-list", archive);
      let more = query(".review-load-more", archive);
      const serviceKeywords = {
        Themes: ["theme", "storefront", "design", "landing page", "homepage", "product-page", "collection-page", "mobile"],
        Apps: ["app", "api", "integration", "algolia", "klaviyo", "finder", "filter", "functionality", "custom code"],
        "Shopify Plus": ["shopify plus", "b2b", "checkout", "enterprise"],
        Subscriptions: ["subscription", "recharge", "loop", "prepaid", "selling plan"],
        "Strategy and UX": ["strategy", "ux", "audit", "design", "journey", "navigation", "merchandising"],
        "Automation and Analytics": ["flow", "automation", "analytics", "tracking", "event", "data layer"],
        "Ongoing Support": ["ongoing", "support", "maintenance", "troubleshooting", "bug", "fix", "updates", "issue", "urgent"],
      };
      const matchesService = (review, selected) => {
        if (selected === "All services") return true;
        const haystack = `${review.title || ""} ${review.category || ""} ${review.service || ""} ${review.clientFeedback || review.text || ""}`.toLowerCase();
        return (serviceKeywords[selected] || []).some(keyword => haystack.includes(keyword));
      };

      const refresh = () => {
        if (!list) return;
        const records = data.all.map((review, vcSourceIndex) => ({ ...review, vcSourceIndex })).filter(review => {
          if (!String(review.clientFeedback || review.text || "").trim()) return false;
          const reviewService = review.platform === "Upwork" ? review.category : review.service;
          if (platform !== "All platforms" && review.platform !== platform) return false;
          if (!matchesService(review, service)) return false;
          return !searchTerm || `${review.title || ""} ${review.reviewer || ""} ${reviewService} ${review.clientFeedback || review.text || ""} ${(review.endorsements || []).join(" ")}`.toLowerCase().includes(searchTerm);
        });
        if (count) count.textContent = String(records.length);
        list.querySelectorAll(".complete-review-card, .review-empty-state").forEach(card => card.remove());
        const html = records.slice(0, visible).map(archiveCard).join("") || '<div class="review-empty-state"><h3>No reviews match those filters.</h3><p>Try another keyword or return to the complete collection.</p></div>';
        if (more) more.insertAdjacentHTML("beforebegin", html);
        else list.insertAdjacentHTML("beforeend", html);
        queryAll(".complete-review-card", list).forEach((card, index) => { card.id = `review-${records[index].vcSourceIndex}`; });
        if (visible < records.length) {
          if (!more) {
            more = document.createElement("div");
            more.className = "review-load-more";
            list.append(more);
          }
          more.hidden = false;
          more.innerHTML = `<button type="button">Show ${Math.min(12, records.length - visible)} more reviews <span class="vc-arrow" data-vc-direction="down" aria-hidden="true">↓</span></button><small>${Math.min(visible, records.length)} of ${records.length} shown</small>`;
          query("button", more)?.addEventListener("click", () => { visible += 12; refresh(); });
        } else if (more) {
          more.hidden = true;
        }
        if (requestedReview && !deepLinkHandled) window.requestAnimationFrame(() => {
          const target = document.getElementById(`review-${requestedReview}`);
          if (!target) return;
          deepLinkHandled = true;
          target.tabIndex = -1;
          target.scrollIntoView({ block: "center" });
          target.focus({ preventScroll: true });
          target.addEventListener("blur", () => target.removeAttribute("tabindex"), { once: true });
        });
      };

      tabs.forEach((tab, index) => tab.addEventListener("click", () => {
        platform = ["All platforms", "Upwork", "Shopify Partner"][index];
        service = "All services";
        if (select) select.value = service;
        visible = 12;
        tabs.forEach(item => item.setAttribute("aria-pressed", String(item === tab)));
        refresh();
      }));
      input?.addEventListener("input", () => { searchTerm = input.value.trim().toLowerCase(); visible = 12; refresh(); });
      select?.addEventListener("change", () => { service = select.value; visible = 12; refresh(); });
      more?.querySelector("button")?.addEventListener("click", () => { visible += 12; refresh(); });
      refresh();
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => void installReviewBrowsers(), { once: true });
  else void installReviewBrowsers();
})();
